let commissionReportTableOptions =  {
  itemsPerPage: 30
}

export default commissionReportTableOptions;
